import React, {Component} from 'react'

import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import Proptypes from 'prop-types'

import {CCIcon, CCActions} from './../../cc-imports'
import Modal from 'react-modal'
import './../../styles/css/layout/CCModalLayout/cc-modal-layout.css'
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";
// import './ccmodal-layout.css'
// import './ccmodal-layout-320.css'

class CCModalLayout extends Component {

    static propTypes = {
        name: Proptypes.string,
        closeModal: Proptypes.func,
    }

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {}
        this._closeModal = this._closeModal.bind(this);
        this._isOpen = this._isOpen.bind(this);
    }

    _closeModal() {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
        else {
            this.props.actions.closeModal(this.props.name);
        }
    }

    componentDidMount() {
        if (this.props.user.user && this.props.user.user.settings) {
            this.setState(this.props.user.user.settings);
        }
    }


    /*_isOpen(name){
        const modals = this.props.modals.modals;
        var isOpen = false;
        if(modals && modals.length>0){
            isOpen = Platform.OS === 'ios' ? ( modals[modals.length-1].name == name && modals[modals.length-1].active==true ): _.find(modals, {name : name})!=null;
        }
        return isOpen;
    }*/

    _isOpen(name) {
        const modals = this.props.modals.modals;
        var isOpen = false;
        if (modals && modals.length > 0) {
            isOpen = modals[modals.length - 1].name == name;
        }
        //console.log("ccModal ", isOpen)
        return isOpen;
    }

    render() {
        const {name} = this.props;
        const isOpen = this._isOpen(name);

        return (
            <CCErrorBoundary>
            <div>
                <Modal overlayClassName={"cc-modal-overlay"} className={"cc-modal-content"} isOpen={isOpen} onRequestClose={this._closeModal}>
                    <div className={"flex-container modal-container"}>
                        <div className={'modal-content flex-container cc-modal-body-layer1'}>
                            <div className={'shadow modal-background cc-modal-body-layer2'}>
                                <div className={'flex-container'} style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                                    {
                                        this.props.children
                                    }
                                </div>
                                <CCIcon onPress={this._closeModal} className={'cc-close-icon-m cc-close-icon'} type={"close"}/>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
            </CCErrorBoundary>

        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(CCModalLayout);


// WEBPACK FOOTER //
// ./src/app/layout/CCModalLayout/CCModalLayout.js